<div class="titulo-receber-form-modal modal fade modal-full-width modal-full-height">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content" *ngIf="isOpen">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>  
            </div>            
            <div class="modal-body"> 
                <sgt-titulo-receber-form
                    #form
                    [id]="idTituloReceber"
                    [embedded]="true"
                    (afterCancel)="cancel()">
                </sgt-titulo-receber-form>
            </div>
            <div class="modal-footer">       
                <ng-template [ngIf]="!readonly && (config?.canInsert || config?.canEdit)">
                    <button type="button" class="btn btn-light" (click)="cancel()">
                        <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
                    </button>
                    <button type="button" class="btn btn-success" (click)="save()" id="btnSaveTituloReceberFormModal">
                        <i class="fas fa-check" aria-hidden="true"></i> Salvar
                    </button>                    
                </ng-template>   
                 
                <ng-template [ngIf]="readonly && config?.canVisualizar">
                    <button type="button" class="btn btn-light" (click)="close()">
                        <i class="fas fa-times"></i> Fechar
                    </button>
                </ng-template>                    
            </div>            
        </div>
    </div>
</div>